module.exports = __webpack_public_path__ + "img/barcode.6cb6592a.svg";